import React from "react";

import { GetStaticProps } from "next";
import {
  BTypeBeneficiaryHead,
  CTypeCardView,
  DTypeBreadCrumb,
  colors,
  FullWidthButton,
} from "goi_common";
import crematorium from "goi_common/src/constants/hwajang_detail.json";
import facilities from "goi_common/src/constants/facilities_detail.json";
import { parlorRegion } from "@/constants/parlorRegion";
import { Box, Stack } from "@mui/material";
import Head from "next/head";

const { regionColor, targetSidos } = parlorRegion;

export const getStaticProps: GetStaticProps = async () => {
  const regionCrematoriums = crematorium.filter((p) =>
    targetSidos.includes(String(p.sido))
  );
  const regionPublicFacilities = facilities.filter(
    (f) => targetSidos.includes(f.sido) && f.is_public
  );
  const description =
    "기초생활수급자 장례 혜택 1)장제급여 80만원 지원 2)공설장지 이용료 무료 3) 전국 화장시설 화장 비용 무료 4) 공설 장례식장 무료";

  return {
    props: {
      regionCrematoriums,
      regionPublicFacilities,
      pageDescription: description,
      pageKeywords: `기초생활수급자 장례, 기초생활수급자 장례, 장제비, 장제급여, 기초생활수급자 장례 얼마`,
      pageOgTitle: `기초생활수급자 장례 시 114 
      (서울경기인천) | 서울경기인천장례정보포털`,
      pageOgDescription: description,
      pageOgImage: "",
    },
  };
};

export default function index({
  regionCrematoriums,
  regionPublicFacilities,
  pageOgTitle,
}: {
  regionCrematoriums: Array<any>;
  regionPublicFacilities: Array<any>;
  pageOgTitle: string;
}) {
  const carouselItems = regionCrematoriums.map((res, i) => {
    return {
      "@type": "ListItem",
      name: `(비용안내) ${res.companyname}`,
      image: `${res.images[0].url}`,
      url: `https://www.metropolitan-funeral.co.kr/benefit/hwajang/${res.companyname}/`,
      position: i + 1,
    };
  });

  const carouselRichSearch =
    regionCrematoriums.length > 6
      ? {
          "@context": "http://schema.org",
          "@type": "ItemList",
          itemListElement: carouselItems,
        }
      : {};
  return (
    <>
      <Head>
        <title>{pageOgTitle}</title>
        {regionCrematoriums.length > 5 && (
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: JSON.stringify(carouselRichSearch),
            }}
          />
        )}
      </Head>
      <DTypeBreadCrumb
        mainColor={regionColor}
        firstItem={{
          text: `수도권 기초생활수급자 장례헬프센터`,
          href: `/benefit/`,
          event: {
            domain: "metro",
            path: "benef",
            trigger_and_target: "br_crumb_benef",
          },
        }}
        goiHomeEvent={{
          domain: "metro",
          path: "benef",
          trigger_and_target: "br_crumb_goi_home",
        }}
      />

      <BTypeBeneficiaryHead
        titleSido="서울 · 경기 · 인천"
        mainColor={regionColor}
        event={{
          domain: "metro",
          path: "benef",
          trigger_and_target: "goi_call",
        }}
      />
      <Stack padding="20px">
        <FullWidthButton
          text="바로 상담하기"
          href="tel:1666-9784"
          backgroundColor={regionColor.c300}
          event={{
            domain: "metro",
            path: "benef",
            trigger_and_target: "goi_call_btom",
          }}
        />
      </Stack>
      <Box padding="0 20px">
        <Box
          width="100%"
          height="1px"
          style={{ background: colors.gray900 }}
          margin="0 0 20px"
          padding="0 20px"
        />
      </Box>

      <Stack padding="40px 20px" marginBottom="40px" gap="8px">
        <h3 className="subtitle_18_b" style={{ textAlign: "center" }}>
          수도권 지역 화장장
        </h3>
        {regionCrematoriums.map((res) => (
          <CTypeCardView
            sigungu={res.sigungu}
            mainColor={regionColor}
            key={res.companyname}
            name={res.companyname}
            href={`/benefit/hwajang/${res.companyname}/`}
            descriptions={["기초생활수급자 무료"]}
            sido={res.sido}
            imgSrc={res.images[0] ? res.images[0].url : ""}
            event={{
              domain: "metro",
              path: "benef",
              trigger_and_target: "uv_fr_crema_detail",
            }}
          />
        ))}
      </Stack>

      <Stack padding="40px 20px" marginBottom="40px" gap="8px">
        <h3 className="subtitle_18_b" style={{ textAlign: "center" }}>
          수도권 지역 장지 (공설)
        </h3>
        {regionPublicFacilities.map((res) => (
          <CTypeCardView
            sigungu={res.sigungu}
            mainColor={regionColor}
            key={res.companyname}
            name={res.companyname}
            href={`/benefit/jangji/${res.companyname}/`}
            descriptions={["기초생활수급자 무료"]}
            sido={res.sido}
            imgSrc={res.images[0] ? res.images[0].url : ""}
            event={{
              domain: "metro",
              path: "benef",
              trigger_and_target: "uv_fr_facility_detail",
            }}
          />
        ))}
      </Stack>
    </>
  );
}
